import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getFaucetCooldown } from "@/lib/api";

const isAddress = (a) => /^0x[0-9a-fA-F]{40}$/.test(a);

export const formatCountdown = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Seconds left until each token can be claimed again for this address, ticking every second
export function useFaucetCooldown(address) {
  const addr = address.trim().toLowerCase();
  const { data, dataUpdatedAt, refetch } = useQuery({
    queryKey: ["faucetCooldown", addr], queryFn: () => getFaucetCooldown(addr), enabled: isAddress(addr),
  });
  const [now, setNow] = useState(Date.now());
  const active = Object.values(data?.remaining || {}).some((s) => s > 0);
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active]);
  const elapsed = Math.floor((now - dataUpdatedAt) / 1000);
  const remainingFor = (token) => (isAddress(addr) ? Math.max((data?.remaining?.[token] || 0) - Math.max(elapsed, 0), 0) : 0);
  return { remainingFor, refetch };
}
